:host {
    display: flex;
    justify-content: center;
    width: 32px;
}

:host > es-button {
    --current-color: var(--color-shade-60);
    --spacing: 6px;
    --border-radius: 50%;
}

:host > es-button[disabled] {
        --current-color: var(--color-shade-50);
    }

.inner {
    opacity: 0;
    transition: opacity 400ms ease;
    border-top: 2px solid var(--color-secondary);
    border-right: 1px solid var(--color-shade-50);
    border-bottom: 1px solid var(--color-shade-50);
    border-left: 1px solid var(--color-shade-50);
    border-radius: 0;
    position: relative;
    box-shadow: none;
}

.inner.entered {
        opacity: 1;
    }
